import styled from 'styled-components'
import SkeletonDefault from 'react-loading-skeleton'
import { Button as ButtonDefault } from '~components'

export const Button = styled(ButtonDefault).attrs({ width: '100%' })`
  margin-top: ${({ theme }) => theme.spacing.km1};
`

export const SkeletonContainer = styled.div `
  > span:first-child span{
    margin-bottom: ${({ theme }) => theme.spacing.km2};
  }
`

export const Skeleton = styled(SkeletonDefault)`
  height: 52px ;
  border-radius: 8px;
`
